module.exports = __webpack_public_path__ + "static/media/icon-assign-user.ba2f798b.svg";